import { render, staticRenderFns } from "./player-credit-transaction.vue?vue&type=template&id=67f0f484&"
import script from "./player-credit-transaction.vue?vue&type=script&lang=js&"
export * from "./player-credit-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports